import Vue from 'vue';
import Vuex from 'vuex';
// import { Col } from 'vant';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    userAvatar: localStorage.getItem('avatar'), //用户头像图片
    userName: localStorage.getItem('name'), //localStorage 用户名
    userPhone: localStorage.getItem('phone'), //用户手机号
    token: localStorage.getItem('token') || '', //用户token
    theme: sessionStorage.getItem('theme'), // 农合联特定字段
    userType: sessionStorage.getItem('userType'),
    addressList: [], //呼呼打药地址列表
    user_region_id: '', //用户的地区id
    durg_ids: '', //药品id
    durg_group_id: '', //套餐药品id
    //新建呼呼打药的数组数据
  },
  mutations: {
    setUserType(state, data) {
      state.userType = data;
      sessionStorage.setItem('userType', data);
    },
    getUserAvatar(state, data) {
      //保存用户头像图片
      state.userAvatar = data;
      localStorage.setItem('avatar', data);
    },
    getUserName(state, data) {
      //保存用户名字
      state.userName = data;
      localStorage.setItem('name', data);
    },
    getUserPhone(state, data) {
      //保存用户手机号码
      state.userPhone = data;
      localStorage.setItem('phone', data);
    },
    getToken(state, data) {
      //保存用户token
      state.token = data;
      localStorage.setItem('token', data);
    },
    getAddressList(state, data) {
      //获取新建呼呼打药的数组数据
      state.addressList.push(data);
    },
    delAddressOne(state, data) {
      //获取新建呼呼打药的数组数据
      state.addressList.splice(data.dindex, 1);
    },
    getUserRegionId(state, data) {
      //保存用户的region_id
      // localStorage.setItem('regionId', data)
      state.user_region_id = data;
    },
    getDurgIds(state, data) {
      //呼呼打药药品id
      state.durg_ids = data;
    },
    getDurgGroupId(state, data) {
      //呼呼套餐 药品id
      state.durg_group_id = data;
    },
    getTheme(state, data) {
      //设置农合联theme
      state.theme = data;
      sessionStorage.setItem('theme', data);
    },
  },
  actions: {},
  modules: {},
});
